import { Immutable } from "immer";
import React, { forwardRef } from "react";

import { tabFeatureAttributeBlock } from "../elementIDs";
import {
    ITabFeatureAttributeBlock_AttributeTab,
    ITabFeatureAttributeBlock_ModelTab,
} from "../models";

import styles from "./index.module.scss";

type TabFeatureAttributeBlockModelTabButtonProps = Immutable<{
    attrIdx: number;
    attrTab: ITabFeatureAttributeBlock_AttributeTab;
    modelIdx: number;
    modelTab: ITabFeatureAttributeBlock_ModelTab;
    onClick: () => void;
    isSelected: boolean;
    onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}>;

export const TabFeatureAttributeBlockModelTabButton = forwardRef<
    HTMLButtonElement,
    TabFeatureAttributeBlockModelTabButtonProps
>(
    (
        {
            attrIdx,
            attrTab,
            modelIdx,
            modelTab,
            onClick,
            isSelected,
            onKeyDown,
        },
        ref,
    ): React.JSX.Element => {
        return (
            <button
                ref={ref}
                className={styles.root}
                id={tabFeatureAttributeBlock.modelTabButton(
                    attrTab,
                    attrIdx,
                    modelTab,
                    modelIdx,
                )}
                type="button"
                role="tab"
                aria-controls={tabFeatureAttributeBlock.modelTabContent(
                    attrTab,
                    attrIdx,
                    modelTab,
                    modelIdx,
                )}
                tabIndex={isSelected ? 0 : -1}
                aria-selected={isSelected}
                onClick={onClick}
                onKeyDown={onKeyDown}
                dangerouslySetInnerHTML={{
                    __html: modelTab.model_name,
                }}
            ></button>
        );
    },
);
TabFeatureAttributeBlockModelTabButton.displayName =
    "TabFeatureAttributeBlockModelTabButton";
